module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-happy.c54f579a.png";